import React from 'react';
import Layout from '../../layout';






function News() {
  return (
   <Layout>
           <section class="page-header padding">
           <div class="overlay"></div>
            <div class="container">
               <div class="section-heading mt-40 text-center">
                    <h4 class="sub-heading">Blog Grid Layout</h4>
                    <h2>Get The Latest Updates Daily!</h2>
                    <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                </div>
            </div>
        </section>

        <section class="blog-section padding">
            <div class="container">
                <div class="blog-wrap row">
                    <div class="col-lg-8 sm-padding">
                        <div class="row">
                            <div class="col-sm-6 padding-15">
                                <div class="blog-item">
                                    <div class="blog-thumb">
                                        <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576544/derma/pmovwk2vmrksw06lofv2.png" alt="post" />
                                        <span class="category"><a href="#">interior</a></span>
                                    </div>
                                    <div class="blog-content">
                                        <h3><a href="blog-details.html">Industrial Factory Building Equipment 2021</a></h3>
                                        <p>Building first evolved out dynamics between needs means available building materials attendant skills.</p>
                                        <a href="blog-details.html" class="read-more">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 padding-15">
                                <div class="blog-item">
                                    <div class="blog-thumb">
                                        <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576543/derma/yrpmtzfkalitkixa7gno.png" alt="post" />
                                        <span class="category"><a href="#">Architecture</a></span>
                                    </div>
                                    <div class="blog-content">
                                       <h3><a href="blog-details.html">The Evolution Of Construction Services 1995.</a></h3>
                                        <p>Building first evolved out dynamics between needs means available building materials attendant skills.</p>
                                        <a href="blog-details.html" class="read-more">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 padding-15">
                                <div class="blog-item">
                                    <div class="blog-thumb">
                                        <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576543/derma/zcxclxtzb7hep87ia7im.png" alt="post" />
                                        <span class="category"><a href="#">Design</a></span>
                                    </div>
                                    <div class="blog-content">
                                        <h3><a href="blog-details.html">Manufacturing The Industries Construction INC.</a></h3>
                                        <p>Building first evolved out dynamics between needs means available building materials attendant skills.</p>
                                        <a href="blog-details.html" class="read-more">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 padding-15">
                                <div class="blog-item">
                                    <div class="blog-thumb">
                                        <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576543/derma/rp3vslc4le9ujv4aqplc.png" alt="post" />
                                        <span class="category"><a href="#">Design</a></span>
                                    </div>
                                    <div class="blog-content">
                                        <h3><a href="blog-details.html">Easy Industrial Management System For Building.</a></h3>
                                        <p>Building first evolved out dynamics between needs means available building materials attendant skills.</p>
                                        <a href="blog-details.html" class="read-more">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 padding-15">
                                <div class="blog-item">
                                    <div class="blog-thumb">
                                        <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576543/derma/mwymf7mlaoxnmpdqzhnu.png" alt="post" />
                                        <span class="category"><a href="#">Design</a></span>
                                    </div>
                                    <div class="blog-content">
                                        <h3><a href="blog-details.html">Stronger Than Most Factory And Building Industries.</a></h3>
                                        <p>Building first evolved out dynamics between needs means available building materials attendant skills.</p>
                                        <a href="blog-details.html" class="read-more">Read More</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 padding-15">
                                <div class="blog-item">
                                    <div class="blog-thumb">
                                        <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576544/derma/a3rr6oi2dvtwhfm8dvvf.png" alt="post" />
                                        <span class="category"><a href="#">Design</a></span>
                                    </div>
                                    <div class="blog-content">
                                        <h3><a href="blog-details.html">The Output Economic Effects For Construction.</a></h3>
                                        <p>Building first evolved out dynamics between needs means available building materials attendant skills.</p>
                                        <a href="blog-details.html" class="read-more">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ul class="pagination-wrap text-left mt-30">
                            <li><a href="#"><i class="las la-arrow-left"></i></a></li>
                            <li><a href="#">1</a></li>
                            <li><a href="#" class="active">2</a></li>
                            <li><a href="#">3</a></li>
                            <li><a href="#"><i class="las la-arrow-right"></i></a></li>
                        </ul>
                    </div>

                    <div class="col-lg-4 padding-15">
                        <div class="sidebar-wrap">
                            <div class="widget-content">
                                <form action="" class="search-form">
                                    <input type="text" class="form-control" placeholder="Type here"/>
                                    <button class="search-btn" type="button"><i class="fa fa-search"></i></button>
                                </form>
                            <div class="widget-content">
                                <h4>Recent Posts</h4>
                                <ul class="thumb-post">
                                    <li><img src="	https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/09/post-1-120x120.jpg" alt="post" /><a href="#">Industrial Factory Building Equipment 2021<span>SEPTEMBER 21, 2020</span></a></li>
                                    <li><img src="	https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/09/post-1-120x120.jpg" alt="post" /><a href="#">The Evolution Of Construction Services 1995<span>SEPTEMBER 21, 2020</span></a></li>
                                    <li><img src="	https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/09/post-1-120x120.jpg" alt="post" /><a href="#">Manufacturing The Industries Construction INC<span>SEPTEMBER 21, 2020</span></a></li>
                                </ul>
                            </div>
                            </div>
                            <div class="widget-content">
                                <h4>Categories</h4>
                                <ul class="widget-links">
                                    <li><a href="#">Architecture</a></li>
                                    <li><a href="#">Interior Design</a></li>
                                    <li><a href="#">Designing</a></li>
                                    <li><a href="#">Construction</a></li>
                                    <li><a href="#">Buildings</a></li>
                                </ul>
                            </div>
                            <div class="widget-content">
                                <h4>Tag Clouds</h4>
                                <ul class="tags">
                                    <li><a href="#">Architecture</a></li>
                                    <li><a href="#">Interior Design</a></li>
                                    <li><a href="#">Designing</a></li>
                                    <li><a href="#">Construction</a></li>
                                    <li><a href="#">Buildings</a></li>
                                    <li><a href="#">Industrial</a></li>
                                    <li><a href="#">Factory</a></li>
                                    <li><a href="#">Material</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
   </Layout>
  );
}

export default News;